import { render } from "./g-cardselect-field.vue?vue&type=template&id=1281f0a0&ts=true"
import script from "./g-cardselect-field.vue?vue&type=script&lang=tsx"
export * from "./g-cardselect-field.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__